import { z } from 'zod';
import {
  CountryCodeSchema,
  HttpUrlSchema,
  IsoDateTimeSchema,
  LanguageCodeSchema,
  NonEmptyTrimmedSchema,
  UuidSchema,
} from './common.js';

export const AuthorRosterEntrySchema = z.object({
  name: NonEmptyTrimmedSchema.max(200),
  credentials: z.string().max(500).default(''),
  topic_tags: z.array(z.string().trim().min(1).max(80)).max(20).default([]),
});
export type AuthorRosterEntry = z.infer<typeof AuthorRosterEntrySchema>;

export const PreferredSourceEntrySchema = z.object({
  name: NonEmptyTrimmedSchema.max(200),
  url: HttpUrlSchema,
  topic_tags: z.array(z.string().trim().min(1).max(80)).max(20).default([]),
});
export type PreferredSourceEntry = z.infer<typeof PreferredSourceEntrySchema>;

export const ProjectSchema = z.object({
  id: UuidSchema,
  tenant_id: UuidSchema,
  name: NonEmptyTrimmedSchema.max(120),
  domain: HttpUrlSchema,
  industry: z.string().nullable(),
  brand_positioning: z.string().nullable(),
  proprietary_assets: z.string().nullable(),
  authors_roster: z.array(AuthorRosterEntrySchema).default([]),
  default_preferred_sources: z.array(PreferredSourceEntrySchema).default([]),
  country_code: CountryCodeSchema,
  language: LanguageCodeSchema,
  created_at: IsoDateTimeSchema,
});
export type Project = z.infer<typeof ProjectSchema>;

export const CreateProjectRequestSchema = z.object({
  name: NonEmptyTrimmedSchema.max(120),
  domain: HttpUrlSchema,
  industry: z.string().max(80).optional(),
  brand_positioning: z.string().max(1000).optional(),
  proprietary_assets: z.string().max(2000).optional(),
  authors_roster: z.array(AuthorRosterEntrySchema).max(50).optional(),
  default_preferred_sources: z.array(PreferredSourceEntrySchema).max(50).optional(),
  country_code: CountryCodeSchema.default('IN'),
  language: LanguageCodeSchema.default('en'),
});
export type CreateProjectRequest = z.infer<typeof CreateProjectRequestSchema>;

export const UpdateProjectRequestSchema = z.object({
  name: NonEmptyTrimmedSchema.max(120).optional(),
  industry: z.string().max(80).nullable().optional(),
  brand_positioning: z.string().max(1000).nullable().optional(),
  proprietary_assets: z.string().max(2000).nullable().optional(),
  authors_roster: z.array(AuthorRosterEntrySchema).max(50).optional(),
  default_preferred_sources: z.array(PreferredSourceEntrySchema).max(50).optional(),
  country_code: CountryCodeSchema.optional(),
  language: LanguageCodeSchema.optional(),
});
export type UpdateProjectRequest = z.infer<typeof UpdateProjectRequestSchema>;
